// Module
var code = "<md-datepicker mn-date ng-model=\"vm.search\"\r\n               md-placeholder=\"{{ 'search' | translate }}\"\r\n               ng-change=\"vm.change()\" ng-model-options=\"{ debounce: 400 }\">\r\n</md-datepicker>";
// Exports
module.exports = code;